import { useEffect } from "react";
import {
  isDashboardPreviewEmbed,
  shouldAllowPreviewAnchorNavigation,
} from "./previewNavigationGuard";

export function usePreviewNavigationGuard(): void {
  useEffect(() => {
    if (!isDashboardPreviewEmbed()) {
      return;
    }

    const allowedOrigin = window.location.origin;

    const onClickCapture = (e: MouseEvent) => {
      if (e.defaultPrevented) {
        return;
      }
      const node = e.target;
      if (!node || !(node instanceof Element)) {
        return;
      }
      const el = node.closest("a[href]");
      if (!el || !(el instanceof HTMLAnchorElement)) {
        return;
      }

      if (!shouldAllowPreviewAnchorNavigation(el, allowedOrigin)) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("click", onClickCapture, true);
    return () => document.removeEventListener("click", onClickCapture, true);
  }, []);
}
